// @ts-nocheck
import * as Types from "../../../../types/types-v2.generated";

import { gql } from "@apollo/client";
import { LogLineFieldsFragmentDoc } from "./LogLineContent.v2.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type LogLinesV2QueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
  first: Types.Scalars["Int"]["input"];
  after?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  databaseId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
  classification?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  postgresRoleId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
  backendPid?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  queryFingerprint?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  from?: Types.InputMaybe<Types.Scalars["Timestamp"]["input"]>;
  to?: Types.InputMaybe<Types.Scalars["Timestamp"]["input"]>;
  logTextMaxLength?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
}>;

export type LogLinesV2Query = {
  __typename?: "RootQuery";
  server: {
    __typename?: "Server";
    id: string;
    logLines: {
      __typename?: "LogLineConnection";
      edges?: Array<{
        __typename?: "LogLineEdge";
        cursor: string;
        node?: {
          __typename?: "LogLine";
          id: string;
          occurredAt: string;
          logClassification?: string | null;
          logText?: string | null;
          backendPid?: number | null;
          databaseId?: string | null;
          postgresRoleId?: string | null;
          postgresRoleName?: string | null;
        } | null;
      } | null> | null;
      pageInfo: {
        __typename?: "PageInfo";
        hasNextPage: boolean;
        endCursor?: string | null;
      };
    };
  };
};

export const LogLinesV2Document = gql`
  query LogLinesV2(
    $serverId: ID!
    $first: Int!
    $after: String
    $databaseId: ID
    $classification: String
    $postgresRoleId: ID
    $backendPid: Int
    $queryFingerprint: String
    $from: Timestamp
    $to: Timestamp
    $logTextMaxLength: Int = 500
  ) {
    server(id: $serverId) {
      id
      logLines(
        first: $first
        after: $after
        databaseId: $databaseId
        classification: $classification
        postgresRoleId: $postgresRoleId
        backendPid: $backendPid
        queryFingerprint: $queryFingerprint
        from: $from
        to: $to
      ) {
        edges {
          cursor
          node {
            ...LogLineFields
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
  ${LogLineFieldsFragmentDoc}
`;

/**
 * __useLogLinesV2Query__
 *
 * To run a query within a React component, call `useLogLinesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useLogLinesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogLinesV2Query({
 *   variables: {
 *      serverId: // value for 'serverId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      databaseId: // value for 'databaseId'
 *      classification: // value for 'classification'
 *      postgresRoleId: // value for 'postgresRoleId'
 *      backendPid: // value for 'backendPid'
 *      queryFingerprint: // value for 'queryFingerprint'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      logTextMaxLength: // value for 'logTextMaxLength'
 *   },
 * });
 */
export function useLogLinesV2Query(
  baseOptions: Apollo.QueryHookOptions<
    LogLinesV2Query,
    LogLinesV2QueryVariables
  > &
    (
      | { variables: LogLinesV2QueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LogLinesV2Query, LogLinesV2QueryVariables>(
    LogLinesV2Document,
    options,
  );
}
export function useLogLinesV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LogLinesV2Query,
    LogLinesV2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LogLinesV2Query, LogLinesV2QueryVariables>(
    LogLinesV2Document,
    options,
  );
}
// @ts-ignore
export function useLogLinesV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    LogLinesV2Query,
    LogLinesV2QueryVariables
  >,
): Apollo.UseSuspenseQueryResult<LogLinesV2Query, LogLinesV2QueryVariables>;
export function useLogLinesV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LogLinesV2Query,
        LogLinesV2QueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  LogLinesV2Query | undefined,
  LogLinesV2QueryVariables
>;
export function useLogLinesV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LogLinesV2Query,
        LogLinesV2QueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LogLinesV2Query, LogLinesV2QueryVariables>(
    LogLinesV2Document,
    options,
  );
}
export type LogLinesV2QueryHookResult = ReturnType<typeof useLogLinesV2Query>;
export type LogLinesV2LazyQueryHookResult = ReturnType<
  typeof useLogLinesV2LazyQuery
>;
export type LogLinesV2SuspenseQueryHookResult = ReturnType<
  typeof useLogLinesV2SuspenseQuery
>;
export type LogLinesV2QueryResult = Apollo.QueryResult<
  LogLinesV2Query,
  LogLinesV2QueryVariables
>;
